var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import uniq from 'lodash.uniq';

var getEntities = function getEntities(combinations, entityKey) {
  switch (entityKey) {
    /* prettier-ignore */
    case 'dow':
      return [0, 1, 2, 3, 4, 5, 6];

    /* prettier-ignore */

    case 'hour':
      return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

    /* prettier-ignore */

    default:
      return uniq(combinations.map(function (x) {
        return x[entityKey];
      }));
  }
};
/* prettier-ignore */


var getCombination = function getCombination(combinations, entityKeyA, entityKeyB, entityA, entityB) {
  return combinations.find(function (x) {
    return x[entityKeyA] === entityA && x[entityKeyB] === entityB;
  });
};

export var addMissingCombinations = function addMissingCombinations(combinations, entityKeyA, entityKeyB) {
  var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    count: 0
  };
  var result = [];
  if (!combinations.length) return result;
  var entitiesA = getEntities(combinations, entityKeyA);
  var entitiesB = getEntities(combinations, entityKeyB);
  entitiesA.forEach(function (entityA) {
    entitiesB.forEach(function (entityB) {
      var _extends2;

      var combination = getCombination(combinations, entityKeyA, entityKeyB, entityA, entityB);
      result.push(combination || _extends((_extends2 = {}, _extends2[entityKeyA] = entityA, _extends2[entityKeyB] = entityB, _extends2), props));
    });
  });
  return result;
};